export default __webpack_public_path__ + "static/lando_cover-c49148f309230c424aaea62b338f0b5d.png";